import { render } from "./AddSert.vue?vue&type=template&id=dd9746ec&scoped=true"
import script from "./AddSert.vue?vue&type=script&lang=js"
export * from "./AddSert.vue?vue&type=script&lang=js"

import "./AddSert.vue?vue&type=style&index=0&id=dd9746ec&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dd9746ec"

export default script